import supportsPerformanceAPI from './supportsPerformanceAPI';

const spaNavigationStartMark = 'spaNavigationStart';

// NOTE: this module servers the same purpose as the `markRouteChange` and
// `getBaselineMark`. It's an experimental version that uses the time of the
// user interaction event instead of the router callback.

export function wasSpaNavigation(): boolean {
  if (!supportsPerformanceAPI()) {
    return false;
  }

  return performance.getEntriesByName('spaNavigationStart').length > 0;
}

export function markSpaNavigationStart(): void {
  if (!supportsPerformanceAPI()) {
    return;
  }

  const theLastUserEventTimestamp = window.event?.timeStamp;

  // NOTE: the navigation starts when the user performs an interaction that
  // triggers the route change; we can assume that it's the time of the last
  // event, such as "click" or "keystroke"; it's a heuristic, as we have no
  // control over how and when React Router callbacks are called
  performance.mark(spaNavigationStartMark, {
    startTime: theLastUserEventTimestamp,
  });
}
